import { Currency } from '@/core/currency/interfaces';

const STN: Currency = {
    name: 'Sao Tome and Príncipe Dobra',
    demonym: 'Sao Tome',
    majorSingle: 'Dobra',
    majorPlural: 'Dobras',
    codeNumeric: '930',
    symbol: 'Db',
    symbolNative: 'Db',
    minorSingle: 'Centimo',
    minorPlural: 'Centimos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'STN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default STN;
